<template>
  <v-dialog
    v-model="isShowDeviceDialog"
    class="device-dialog"
    @click:outside="onCancel"
    @keydown.esc="onCancel"
    max-width="500"
  >
    <v-card class="px-5 py-5" color="#21343b" width="auto">
      <v-row no-gutters align="center" justify="center">
        <v-col class="mb-6" :cols="12" align="start" justify="start">
          <span class="title">{{ $t('recordingSettings') }}</span>
        </v-col>
      </v-row>
      <v-select
        v-model="form.audioId"
        :items="audioDeviceList"
        item-text="deviceLabel"
        item-value="deviceId"
        :label="$t('audioInput')"
        class="select"
        outlined
        return-object
        dark
        hide-details
      ></v-select>
      <v-select
        v-model="form.videoId"
        :items="mediaDeviceList"
        item-text="deviceLabel"
        item-value="deviceId"
        :label="$t('videoInput')"
        class="select mt-5"
        outlined
        return-object
        dark
        hide-details
      ></v-select>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'MediaDeviceList',
  props: {
    isShowDeviceDialog: Boolean,
    isDeviceListGranted: Boolean,
  },
  created() {},
  data() {
    return {
      form: {
        audioId: '',
        audioLabel: '',
        videoId: '',
        videoLabel: '',
      },
      audioDeviceList: [],
      mediaDeviceList: [],
      formLabelWidth: '100px',
    }
  },
  methods: {
    onCancel() {
      this.$emit('callBack', this.form)
    },
    async getMediaDeviceList() {
      let self = this
      this.audioDeviceList = []
      this.mediaDeviceList = []

      if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
        return
      }
      if (!this.isDeviceListGranted) {
        // 권한을 받아오기 위해 임시로 호출해준다.
        let tempStream = await navigator.mediaDevices.getUserMedia({
          video: true,
          audio: true,
        })

        tempStream.getTracks().forEach((track) => track.stop())
        tempStream.stream = null
      }

      // List cameras and microphones.
      let devices = await navigator.mediaDevices.enumerateDevices()

      devices.forEach((device) => {
        let data = {
          deviceId: device.deviceId,
          deviceLabel: device.label,
        }

        if (device.kind.startsWith('audioinput') && device.deviceId !== 'default') {
          if (this.form.audioId === '' && this.form.audioLabel === '') {
            this.form.audioId = device.deviceId
            this.form.audioLabel = device.label
          }
          self.audioDeviceList.push(data)
        } else if (device.kind.startsWith('video')) {
          if (this.form.videoId === '' && this.form.videoLabel === '') {
            this.form.videoId = device.deviceId
            this.form.videoLabel = device.label
          }
          self.mediaDeviceList.push(data)
        }
      })
    },
  },
  watch: {
    isShowDeviceDialog(to) {
      if (to) {
        this.getMediaDeviceList()
      }
    },
  },
}
</script>
<style scoped>
span {
  color: #eee;
}
.title {
  color: #ddd;
  font-size: 17px !important;
  font-weight: 500;
}
.select {
  color: #eee;
  font-size: 14px;
  font-weight: 400;
}
.v-menu__content .v-list {
  background-color: #21343b;
  border: 1px solid #869399;
}
.v-menu__content .v-list >>> .v-list-item__title {
  font-size: 14px;
  font-weight: 400;
  color: #eee;
}
</style>
